import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Background as Component } from './components/background';
import styles from './styles/styles.css';
import type { IBgDeps, TBackground } from './models';

export const Background = createWidget<IBgDeps, TBackground>({
    styles,
})(Component);
